import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, CDN_URL, formatDate, formatMoney, formatMoneyShorten, getCurrentTimestamp } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";
import OneOutstandingPaymentCycle from "../ones/OneOutstandingPaymentCycle";
import OnePaymentRecord from "../ones/OnePaymentRecord";
import logo from '../assets/logo.png';
import { useReactToPrint } from "react-to-print";
import { useRef } from "react";
import { MdPrint } from "react-icons/md";

export default function View({ uuid }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [paymentRecordData, setPaymentRecordData] = useState(null);
	const [cycleData, setCycleData] = useState(null);
	const [studentData, setStudentData] = useState(null);
	const [studentPaymentsProfile, setStudentPaymentsProfile] = useState(null);
	const [paymentProfileInScope, setPaymentProfileInScope] = useState(null);
	const [loading, setLoading] = useState(false);

  const [amount, setAmount] = useState(0);
	const [payWith, setPayWith] = useState("bank");
	const [paymentDate, setPaymentDate] = useState("");
	const [receiptId, setReceiptId] = useState("");

	const invoiceRef = useRef(null);
	

	const printInvoice = useReactToPrint({
		contentRef: invoiceRef,
		documentTitle: "Invoice", // optional
	});
	
	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			getPaymentRecordData(),
		]);
		setReady(true);
	}

	async function getPaymentRecordData() {
		await callApi("get-payment-record-data", { uuid }).then(async response => {
			if (response.status === 1) {
				setPaymentRecordData(response.data);

				await Promise.all([
					getCycleData(response.data),
					getStudentData(response.data),
					getStudentPaymentsProfile(response.data),
				]);

			} else {
				appContext.tellError("Could not fetch data, check your connection");
			}
		})
	}



	function getPaymentProfileInScope() {

		if(paymentRecordData && studentPaymentsProfile) {
			let cycleUuid = '';
			let cycles = null;

			if(paymentRecordData.generalPaymentCycleUuid) {

				cycleUuid = paymentRecordData.generalPaymentCycleUuid;
				cycles = studentPaymentsProfile.allGeneralPaymentCycles;

			} else if(paymentRecordData.individualPaymentCycleUuid) {
				
				cycleUuid = paymentRecordData.individualPaymentCycleUuid;
				cycles = studentPaymentsProfile.allIndividualPaymentCycles;

			} else if(paymentRecordData.debtUuid) {
				
				cycleUuid = paymentRecordData.debtUuid;
				cycles = studentPaymentsProfile.allDebts;

			}

			if(cycleUuid && cycles) {
				for (const _profile of cycles) {
					if(_profile.uuid === cycleUuid) {
						setPaymentProfileInScope(_profile);
					}
				}
			}


		}
		

		
	}

	async function getCycleData(_record) {
		let url = '';
		let cycleUuid = '';

		if(_record.generalPaymentCycleUuid) {
			url = 'get-general-payment-cycle-data';
			cycleUuid = _record.generalPaymentCycleUuid;
		} else if(_record.individualPaymentCycleUuid) {
			url = 'get-individual-payment-cycle-data';
			cycleUuid = _record.individualPaymentCycleUuid;
		} else if(_record.debtUuid) {
			url = 'get-debt-data';
			cycleUuid = _record.debtUuid;
		}

		await callApi(url, { uuid: cycleUuid  }).then(response => {
			if (response.status === 1) {
				setCycleData(response.data);
			} else {
				appContext.tellError("Could not fetch data, check your connection");
			}
		})
	}
	

	async function getStudentData(_record) {
		
		await callApi('get-student-data', { uuid: _record.studentUuid, }).then(response => {
			if (response.status === 1) {
				setStudentData(response.data);
			} else {
				appContext.tellError("Could not fetch data, check your connection");
			}
		})
	}

	async function getStudentPaymentsProfile(_record) {
		
		await callApi('get-student-payments-profile', { uuid: _record.studentUuid, }).then(response => {
			if (response.status === 1) {
				setStudentPaymentsProfile(response.data);
			} else {
				appContext.tellError("Could not fetch data, check your connection");
			}
		})
	}

  async function editPayment() {
		const receiptFile = document.getElementById("_receiptFile").files[0];

		if(!isNaN(amount) && Number(amount) > 0) {
			if(payWith && payWith.trim().length > 0) {
				if(
					(receiptId && receiptId.trim().length > 0) ||
					receiptFile
				) {
					if(paymentDate && paymentDate.trim().length > 0) {
						setLoading(true);
						await callApi(
							'edit-payment-record',
							{
                uuid,
								amount,
								payWith,
								receiptId,
								receiptFile: (receiptFile || ''),
								paymentDate,
								
							}
						).then(response => {
							if(response.status === 1) {
								appContext.tellMessage("Payment record was updated");
								init();
							} else {
								appContext.tellError(response.msg);
							}
						})
						setLoading(false);
					} else {
						appContext.tellError("Invalid payment date");
					}
				} else {
					appContext.tellError("Provide either receipt file or ID");
				}
			} else {
				appContext.tellError("Invalid payment method");
			}
		} else {
			appContext.tellError("Invalid amount paid");
		}
	}


	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		getPaymentProfileInScope();
	}, [ studentPaymentsProfile, paymentRecordData ])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [loading])

  useEffect(() => {
    if(paymentRecordData) {
      setAmount(paymentRecordData.amount);
      setPayWith(paymentRecordData.payWith);
      setReceiptId(paymentRecordData.receiptId);
      setPaymentDate(paymentRecordData.paymentDate)
    }
  }, [ paymentRecordData ])

	if (ready && paymentRecordData && cycleData && studentData && paymentProfileInScope) {

    const invoiceBody = (
    
      <div className="row">
        
        <div className="col-6">
          <div className="d-flex">
            <img
              src={logo}
              style={{
                width: "50px",
                flexShrink: 0,
                height: "auto",
              }}
            />
            <h6
              className="font-bold"
              style={{
                fontSize: "18px",
                textTransform: "uppercase",
                wordWrap: "break-word",
              }}
            >
              {appContext.currentSchoolData.name}
            </h6>
          </div>

          <h6
            className="font-bold"
            style={{
              fontSize: "12px"
            }}
          >
            Email: {appContext.currentSchoolData.contactEmail}
          </h6>
          <h6
            className="font-bold"
            style={{
              fontSize: "12px"
            }}
          >
            Phone: {appContext.currentSchoolData.contactPhone}
          </h6>
          <h6
            className="font-bold"
            style={{
              fontSize: "12px"
            }}
          >
            Website: {appContext.currentSchoolData.contactWebsite}
          </h6>
          <h6
            className="font-bold"
            style={{
              fontSize: "12px"
            }}
          >
            Address: {appContext.currentSchoolData.contactAddress}
          </h6>
        </div>

        <div className="col-6">
          <h6
            style={{
              fontSize: "18px"
            }}
            className="font-bold   text-end"
          >
            PAYMENT RECEIPT
          </h6>

          <h6
            style={{
              fontSize: "14px",
              textTransform: "uppercase",
            }}
            className="font-bold text-end"
          >
            {cycleData.title}
          </h6>

          <h6
            style={{
              fontSize: "12px"
            }}
            className="font-semi-bold   text-end"
          >
            Issuance Date: {formatDate(getCurrentTimestamp())}
          </h6>
          <h6
            style={{
              fontSize: "12px"
            }}
            className="font-semi-bold   text-end"
          >
            Receipt ID: <span className="">{paymentRecordData.uuid}</span>
          </h6>

          <h6
            style={{
              fontSize: "12px"
            }}
            className="font-semi-bold   text-end"
          >
            Submitted Receipt ID: <span className="">{paymentRecordData.receiptId || 'N/A'}</span>
          </h6>

          

        </div>

        <div className="col-12">
          <hr/>
        </div>

        <div className="col-4">
          <label className="form-label">Payment Details:</label>
          <h6
            style={{
              fontSize: "12px",
            }}
            className="font-regular"
          >
            AMOUNT PAID: <span className="font-bold">{formatMoney(paymentRecordData.amount)} TZS</span>
          </h6>

          <h6
            style={{
              fontSize: "12px",
            }}
            className="font-regular"
          >
            DATE PAID: <span className="font-bold">{paymentRecordData.paymentDate}</span>
          </h6>

          
          
        </div>

        <div className="col-4">
          <label className="form-label">Student Details:</label>
          <h6
            style={{
              fontSize: "14px",
            }}
            className="font-bold"
          >
            {studentData.firstName} {studentData.middleName} {studentData.lastName}
          </h6>
          <h6
            style={{
              fontSize: "14px",
            }}
            className="font-bold"
          >
            {studentData.classroomName} 
          </h6>
          <h6
            style={{
              fontSize: "14px",
            }}
            className="font-regular"
          >
            {studentData.streamName} 
          </h6>
        </div>

        <div className="col-4">
          
          <h6
            style={{
              fontSize: "12px",
            }}
            className="font-semi-bold"
          >
            TOTAL DUE: <span className="font-bold">{formatMoney(cycleData.totalAmount || cycleData.amount)} TZS</span>
          </h6>

          <h6
            style={{
              fontSize: "12px",
            }}
            className="font-semi-bold"
          >
            TOTAL PAID: <span className="font-bold">{formatMoney(paymentProfileInScope.amountPaid)} TZS</span>
          </h6>

          <h6
            style={{
              fontSize: "12px",
            }}
            className="font-semi-bold"
          >
            TOTAL DISCOUNT: <span className="font-bold">{formatMoney(paymentProfileInScope.discountIssued)} TZS</span>
          </h6>

          <h6
            style={{
              fontSize: "12px",
            }}
            className="font-semi-bold"
          >
            REMAINING BALANCE: <span className="font-bold">{formatMoney(paymentProfileInScope.balance)} TZS</span>
          </h6>
          
        </div>

        {
          (cycleData.items) ?
          <div className="col-12">
            
            <hr/>

            <h6
              className="font-regular"
              style={{
                fontSize: "12px"
              }}
            >
              ITEMS
            </h6>

            <table
              className="table table-striped"
              style={{
                fontSize: "14px"
              }}
            >
              <thead className="font-semi-bold">
                <tr>
                  <td>Name</td>
                  <td>Quantity</td>
                  <td>Amount in TZS</td>
                  <td>Sub Total in TZS</td>
                </tr>
              </thead>

              <tbody>
                {
                  (JSON.parse(cycleData.items).map((item, i) => {
                    return (
                      <tr key={i}>
                        <td>{item.name}</td>
                        <td>{item.quantity}</td>
                        <td>{formatMoney(item.amount)}</td>
                        <td>{formatMoney(item.subTotal)}</td>
                      </tr>
                    )
                  }))
                }
              </tbody>
              
            </table>
          </div>
          :
          <div className="col-12">
            <hr/>
            <table
              className="table table-striped"
              style={{
                fontSize: "14px"
              }}
            >
              <thead className="font-semi-bold">
                <tr>
                  <td>Name</td>
                  <td>Quantity</td>
                  <td>Amount in TZS</td>
                  <td>Sub Total in TZS</td>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>{cycleData.title}</td>
                  <td>1</td>
                  <td>{formatMoney(paymentRecordData.amount)}</td>
                  <td>{formatMoney(paymentRecordData.amount)}</td>
                </tr>
              </tbody>
              
            </table>
          </div>
        }

        <div className="col-6">
          <label style={{ fontSize: "12px" }} className="form-label">Offered By:</label>
          <h6 style={{ fontSize: "12px" }}>NAME: <span className="font-bold">{appContext.currentUserData.firstName} {appContext.currentUserData.middleName} {appContext.currentUserData.lastName}</span></h6>
          <h6 style={{ fontSize: "12px" }}>SIGNATURE: _____________________</h6>
        </div>

        <div className="col-6">
          <label style={{ fontSize: "12px" }} className="form-label">Received By:</label>
          <h6 style={{ fontSize: "12px" }}>NAME: _____________________</h6>
          <h6 style={{ fontSize: "12px" }}>SIGNATURE: _____________________</h6>
        </div>

      </div>    
      
    );

		return (
			<div
				className="container"
			>
				<div className="row">

					<div className="col-12 mb-4">
						<h6 className="main-section-title">
							Payment for "{cycleData.title}"
							
						</h6>
						<hr/>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<div className="card">
							<div className="card-body">
								<h6 className="card-title">Receipt</h6>
								<hr/>

								<div 
									className=""
									style={{
										overflowX: "scroll"
									}}
								>
                  <div
                    style={{
                      padding: "10px",
                      minWidth: "600px",
                      padding: "20px",
                    }}
                    ref={invoiceRef}
                  >

                    
                    {invoiceBody}
                  
                    <div 
                      className="bg-dark"
                      style={{
                        width: "100%",
                        height: "20px",
                        marginTop: "10px",
                        marginBottom: "10px",
                      }}
                    />

                    {invoiceBody}
                    

                  </div>
									
								</div>

								<div className="text-end">
									<button
										className="btn btn-sm btn-dark"
										onClick={printInvoice}
									>
										<MdPrint size={18}/> Print
									</button>
								</div>

							</div>
						</div>
					</div>

					<div className="col-md-12 mt-2 mb-2">
						<div className="card">
							<div className="card-body">
								<h6 className="card-title">Edit Payment</h6>
								<hr/>

								<div className="row">
                  <div className="col-md-12 mt-2 mb-2">
                    <label className="form-label">Amount</label>
                    <input
                      className="form-control"
                      value={amount}
                      onChange={(e) => setAmount(e.target.value)}
                    />
                  </div>

                  <div className="col-md-6 mt-2 mb-2">
                    <label className="form-label">Payment Date</label>
                    <input
                      className="form-control"
                      value={paymentDate}
                      onChange={(e) => setPaymentDate(e.target.value)}
                      type="date"
                    />
                  </div>

                  <div className="col-md-6 mt-2 mb-2">
                    <label className="form-label">Paid with</label>
                    <select
                      className="form-control"
                      value={payWith}
                      onChange={(e) => setPayWith(e.target.value)}
                    >
                      <option value=""></option>
                      <option value="cash" >Cash</option>
                      <option value="bank" >Bank</option>
                      <option value="credit_card" >Credit Card</option>
                      <option value="mobile_money" >Mobile Money</option>
                    </select>
                  </div>

                  <div className="col-md-12 mt-2 mb-2">
                    <label className="form-label">Receipt ID</label>
                    <input
                      className="form-control"
                      value={receiptId}
                      onChange={(e) => setReceiptId(e.target.value)}
                      readOnly
                    />
                  </div>

                  <div className="col-md-12 mt-2 mb-2 d-none">
                    <label className="form-label">Receipt File</label>
                    <input
                      className="form-control"
                      type="file"
                      id="_receiptFile"
                    />
                  </div>

                  <div className="col-md-12 mt-2 mb-2">
                    <button
                      className="btn btn-block btn-primary btn-padded btn-rounded"
                      onClick={() => {
                        
                        appContext.activateDialog({
                          message: "Are you  sure you want to make changes to this payment record?",
                          onConfirm: editPayment,
                        })
                          
                      }}
                    >
                      SUBMIT
                    </button>
                  </div>

                </div>
                

							</div>
						</div>
					</div>

					

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}